export function validatePasswordReset(values) {
    let errors = {}

    if (!values.password)
        errors.password = "Password is required"
    else if (values.password && values.password.length < 8)
        errors.password = "Use 8 or more characters"
    else if (values.password && values.password.length > 50)
        errors.password = "Max. characters limit is 100"
    else if (!values.confirmPassword)
        errors.confirmPassword = "Confirm your password"
    else if (values.password && values.confirmPassword && values.password !== values.confirmPassword)
        errors.confirmPassword = "Password do not match"

    return errors;
}